export type AppConfigAction =
  | SetFullscreenAction
  | ClearFullscreenAction
  | SetSideNavExpandedAction;

type SetFullscreenAction = {
  type: 'app-config/set-fullscreen';
};

type ClearFullscreenAction = {
  type: 'app-config/clear-fullscreen';
};

type SetSideNavExpandedAction = {
  type: 'app-config/set-side-nav-expanded';
  payload: boolean;
};

export const SET_FULLSCREEN: 'app-config/set-fullscreen' =
  'app-config/set-fullscreen';
export const CLEAR_FULLSCREEN: 'app-config/clear-fullscreen' =
  'app-config/clear-fullscreen';
export const SET_SIDE_NAV_EXPANDED: 'app-config/set-side-nav-expanded' =
  'app-config/set-side-nav-expanded';

export const setFullscreen = (): SetFullscreenAction => ({
  type: SET_FULLSCREEN,
});

export const clearFullscreen = (): ClearFullscreenAction => ({
  type: CLEAR_FULLSCREEN,
});

export const setSideNavExpanded = (
  expanded: boolean,
): SetSideNavExpandedAction => ({
  type: SET_SIDE_NAV_EXPANDED,
  payload: expanded,
});
